<script setup>
import { useI18n } from 'vue-i18n';
import { ref, computed } from 'vue';
import { useTestsStore, useTestRenderStore } from '@stores';
import { useRouter, useRoute } from 'vue-router';

const testsStore = useTestsStore();
// const renderStore = useTestRenderStore();

const { t } = useI18n({ useScope: 'global' });
const router = useRouter();
const route = useRoute();

const examLanguage = ref(route.query.lang);
const examId = ref(route.query.exam_id);

const languages = computed(() => {
    return testsStore.main.languages?.filter((lang) => testsStore.main.selectedLanguages.includes(lang.code));
});

const createExamHandler = async () => {
    if (examLanguage.value) {
        examId.value = await testsStore.createExamId(examLanguage.value);
        router.push({ query: { exam_id: examId.value, lang: examLanguage.value } });
    }
};

const iframeBaseUrl = computed(() => `${window.location.protocol}//${window.location.host}/testing`);
</script>

<template>
    <Card>
        <template #content>
            <div class="create-test">
                <p>{{ t('tests.testStart') }}</p>
                <div class="create-test-right">
                    <Select for="languages" optionValue="code" name="languages" v-model="examLanguage" :options="languages" optionLabel="name" :placeholder="t('tests.selectLangs')" />
                    <Button :label="t('tests.createExam')" @click="createExamHandler" :disabled="!examLanguage" />
                </div>
            </div>
            <iframe v-if="examId" class="test-render" :src="`${iframeBaseUrl}?exam_id=${examId}&role=admin`"></iframe>
            <!-- ?question=${renderStore.currentQuestionId} -->
        </template>
    </Card>
</template>

<style scoped>
.create-test {
    @apply flex gap-4 items-center justify-between;
}
.create-test-right {
    @apply flex gap-4 items-center;
}
.test-render {
    @apply w-full h-[calc(100vh-360px)] mt-8 border border-gray-200 rounded-xl;
}
</style>
